import * as Query from '@web/contracts/Query';
export const Keys: Query.Search.Recent.Keys = {
  list: 'recent-list',
  'quick-view': 'recent-quick-view',
};
